import { useLoginBehavior, LoginBehavior } from "~/lib/client/useLoginBehavior";
import { Link, LinkProps } from "~/ui-library";

export interface LoginLinkProps extends Omit<LinkProps, "href"> {
  behavior?: LoginBehavior;
}
export function LoginLink({
  onClick,
  behavior = {
    type: "window",
  },
  children,
  ...rest
}: LoginLinkProps): JSX.Element {
  const handler = useLoginBehavior();
  return (
    <Link
      {...rest}
      href="#"
      onClick={(event) => {
        if (onClick !== undefined) {
          onClick(event);
        }
        if (event.defaultPrevented) {
          return;
        }
        handler(behavior);
      }}
    >
      {children}
    </Link>
  );
}
